<template>
  <form
    v-loading="loading"
    @submit.prevent="submit()"
  >
    <slot :errors="errors" />

    <slot name="submit" />
  </form>
</template>

<script>
import { serialize } from "object-to-formdata";
import notificator from "@/services/notificator";

export default {
  name: "v-form",
  props: {
    data: {
      required: true,
      type: Object,
    },
    url: {
      required: true,
      type: String,
    },
    method: {
      required: true,
      type: String,
      validator(value) {
        return ["post", "patch"].indexOf(value) !== -1;
      },
    },
    formDataOptions: {
      default() {
        return {
          nullsAsUndefineds: false,
          booleansAsIntegers: true,
          allowEmptyArrays: true,
        };
      },
      type: Object,
    },
    format: {
      type: String,
      default() {
        return "json";
      },
      validator(value) {
        return ["json", "formData"].indexOf(value) !== -1;
      },
    },
    beforeSubmit: {
      default(next) {
        return next();
      },
      type: Function,
    },
    onSuccess: {
      default(response) {
        notificator.open({
          message: response.data.message,
          type: "success",
        });
      },
      type: Function,
    },
    onError: {
      default(error) {
        //
      },
      type: Function,
    },
    showErrorNotification:{
      default: true,
      type: Boolean,
    },
    showSuccessNotification:{
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      errors: {},
      dirty: false,
    };
  },
  methods: {
    isDirty() {
      this.dirty = true;
      this.$emit("dirty");
    },
    submit() {
      this.beforeSubmit(this.query);
    },
    query() {
      if (!this.loading) {
        this.loading = true;

        let method = this.method;
        let data = this.data;
        let headers = { "Content-Type": "application/json" };

        if (this.format == "formData") {
          method = "post";

          data = serialize(this.data, this.formDataOptions);

          if (this.method != "post") {
            data.append("_method", this.method);
          }

          headers = {
            "Content-Type": "multipart/form-data",
          };
        }

        this.$http[method](this.url, data, { headers: headers })
          .then((response) => {
            this.loading = false;
            this.errors = {};

            if (this.showSuccessNotification) {
              this.onSuccess(response);
            }

            this.$emit("success", response);
          })
          .catch((error) => {
            console.error(error);

            this.loading = false;

            if (error.response && error.response.status == 422) {
              this.loadErrors(error);
            }
            if (this.showErrorNotification) {
              this.onError(error);
            }

            this.$emit("error", error);
          });
      }
    },
    loadErrors(error) {
      this.errors = error.response.data.errors;
    },
    clearErrors(name = null) {
      if (name == null) {
        this.errors = {};
      } else {
        this.$delete(this.errors, name);
      }
    },
  },
};
</script>
